module.exports = __webpack_public_path__ + "img/image3.25498d77.png";